export function ByzWaterLevel({ waterLevel }) {
    const widthHeight = "w-[38px] h-[38px]"
    return (
        <div className="w-[40px] h-[40px] showCisternLevel border-solid border" style={{ color: "#F7D79E",borderColor: 'var(--main-color)', backgroundImage: 'url("/sheepCounter/background.png")' }}>
            <div className='mt-1 cistern' style={{ "--mask-step": waterLevel }}>
                <img className={`absolute ${widthHeight}`} src="/WaterLevel/cistern_background.png" alt="" />
                <img className={`absolute waterLevel ${widthHeight}`} src="/WaterLevel/cistern_level_indicator.png" alt="" />
                {waterLevel <= "1" ? <img className={`absolute ${widthHeight}`} src="/WaterLevel/cistern_outline_min.png" alt="" />
                    : waterLevel === "5" ? <img className={`absolute ${widthHeight}`} src="/WaterLevel/cistern_outline_max.png" alt="" />
                        : <img className={`absolute ${widthHeight}`} src="/WaterLevel/cistern_outline.png" alt="" />}
                <div className={`absolute text-xl flex text-center justify-center align-center items-center ${widthHeight}`}>
                    <h1 className={``}>{waterLevel}</h1>
                </div>
            </div>
        </div>
    )
}